import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

export const TextOnlyTooltip = withStyles({
    tooltip: {
        backgroundColor: '#00438b !important',
        fontSize: '0.7em !important',
        marginBottom: '-0.1em'
    }
})(Tooltip);